import styled from 'styled-components';
import { Icon } from 'semantic-ui-react';
import { colors, verticalGutter } from '../../../styles';

export const StyledIcon = styled(Icon)`
  &,
  &.icon {
    position: absolute;
    top: 0.5rem;
    right: 0;
    pointer-events: none;
    color: ${colors.darkGrey};

    + .datepicker__icon {
      right: 2rem;
      pointer-events: initial;
    }
  }

  + .ui.input {
    padding-right: ${verticalGutter * 2}rem;
  }
`;

export default styled.div`
  position: absolute;
  left: 0;
  opacity: 0;
  transition: opacity 0.3s ease;
  z-index: -1;

  &,
  .DayPicker,
  .DayPicker-Month {
    width: 100%;
  }

  /* react-day-picker override */
  .DayPicker {
    position: relative;
    &:before {
      content: '';
      position: absolute;
      width: 100%;
      height: 100%;
      background: #fff;
      border-radius: 4px;
      left: 0;
      top: 0;
      box-shadow: 0 0 1rem rgba(0, 0, 0, 0.3);
      z-index: -1;
    }

    &-Caption,
    &-Weekday {
      position: relative;
      font-weight: bold;
      overflow: hidden;
      > * {
        position: relative;
        z-index: 2;
      }
      &:before {
        content: '';
        position: absolute;
        left: -1rem;
        right: -1rem;
        top: 0;
        bottom: 0;
        background: ${colors.lighterGrey};
      }
    }

    &-Caption {
      margin-bottom: 0;
      padding: 0.75rem 0.5rem 0;
      text-align: center;
    }

    &-Weekday {
      text-transform: uppercase;
    }

    &-Month {
      margin: 0;
    }

    &-Day {
      position: relative;
      background: transparent !important;
      > * {
        position: relative;
        z-index: 1;
      }
      &:focus {
        outline: none;
      }
      &:before {
        content: '';
        position: absolute;
        left: 50%;
        display: block;
        width: 2.5rem;
        height: 2.5rem;
        border-radius: 50%;
        background: transparent;
        transition: background 0.3s ease;
        transform: translateX(-50%);
        z-index: -1;
      }
      &:after {
        content: '';
        width: 0;
        height: 2.5rem;
        display: inline-block;
        vertical-align: middle;
      }

      &--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside) {
        &:before {
          background: ${colors.primary};
        }
      }

      &:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside):not(.DayPicker-Day--selected):hover {
        &:before {
          background: ${colors.lighterGrey};
        }
      }

      &--today {
        color: ${colors.primary};
      }

      &--disabled {
        color: inherit;
        opacity: 0.3;
      }
    }

    &-NavButton {
      z-index: 9;
      top: 0.95rem;

      &--next {
        right: 25%;
      }
      &--prev {
        right: auto;
        left: 25%;
      }
    }
  }

  /* namespace'd styles */
  &.datepicker {
    &--active {
      opacity: 1;
      z-index: 9;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/FormComponents/Datepicker/Datepicker.style.js